var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-component"},[_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',{staticClass:"percent"}),_c('div',{staticClass:"progress2 progress-moved"},[_c('div',{staticClass:"progress-bar2"})])])
}]

export { render, staticRenderFns }